import React from 'react';
import { numberFormat } from '../../util/araknerdlib';
const badgeTone = (s) =>
  s === 'Reconciled' ? 'success' : s === 'Pending' ? 'warning' : 'secondary';



const WalletCard = ({ bank, onEdit, currency, onDeposit, onManage, onDelete, handleStatement, onWithdraw }) => (
  <div
    className="card shadow-sm border-0"
    style={{ transition: 'box-shadow .2s, transform .2s' }}
    onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-2px)')}
    onMouseLeave={(e) => (e.currentTarget.style.transform = 'none')}
  >
    <div className="card-body d-flex flex-column">
      <div className="d-flex align-items-start">
        <span
          className="rounded d-inline-flex align-items-center justify-content-center mr-3"
          style={{ width: 48, height: 48, background: '#EEF2F6' }}
        >
          <i className="fa fa-university" />
        </span>

        <div className="flex-grow-1">
          <div className="font-weight-semibold">
            {bank.bank_name} <span className="text-muted">• {bank.account_number}</span>
          </div>
          <div className="text-muted small">{bank.address}</div>
        </div>

        {/* Status + Manage dropdown */}
        <div className="d-flex align-items-start">
          <span className={`badge badge-${badgeTone(bank?.account_info?.status)} mr-2`}>{bank?.account_info?.status || 'Unknown'}</span>

          <div className="btn-group">
            <button
              type="button"
              className="btn btn-sm btn-light dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              title="Manage account"
            >
              <i className="fa fa-ellipsis-h" />
            </button>
            <div className="dropdown-menu dropdown-menu-right">
              <button className="dropdown-item" onClick={() => onEdit(bank)}>
                <i className="fa fa-edit mr-2" />
                Edit Bank Details
              </button>
              <div className="dropdown-divider" />
              <button className="dropdown-item" onClick={() => handleStatement(bank)}>
                <i className="fa fa-file-alt mr-2" />
                Bank Statement
              </button>
              <button className="dropdown-item text-danger" onClick={() => onDelete(bank)}>
                <i className="fa fa-trash-alt mr-2" />
                Delete Bank
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Balances */}
      <div className="mt-3 d-flex align-items-center justify-content-between">
        <div>
          <div className="text-muted small">Actual Balance</div>
          <div className="h5 mb-0">{currency} {numberFormat(bank?.account_info?.balance?.amount || 0)}</div>
        </div>
        <div className="text-right">
          <div className="text-muted small">Prov. Balance</div>
          <div className="h6 mb-0">{currency} {numberFormat(bank?.account_info?.provisional_balance || 0)}</div>
        </div>
      </div>

      {/* Progress: reconciliation completion */}
      <div className="mt-3">
        <div className="d-flex justify-content-between small text-muted mb-1">
          <span>Reconciliation</span>
          <span>{bank?.account_info?.clearing_progress || 0}%</span>
        </div>
        <div className="progress" style={{ height: 8 }}>
          <div
            className="progress-bar bg-success"
            style={{ width: `${bank?.account_info?.clearing_progress || 0}%` }}
          />
        </div>
      </div>

      {/* Actions */}
      <div className="mt-auto pt-3 d-flex justify-content-between">
        <button className="btn btn-sm btn-outline-primary" onClick={() => onDeposit(bank)}>
          <i className="fa fa-plus mr-1" />
          Collect
        </button>
        <div className="btn-group">
          <button className="btn btn-sm btn-light" onClick={()=> onWithdraw(bank)}>
            <i className="fa fa-minus mr-1" />
            Payout
          </button>
          <button className="btn btn-sm btn-outline-secondary" onClick={() => onManage(bank)}>
            <i className="fa fa-cog mr-1" />
            Manage
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default WalletCard;